/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const opbnb_chain_about = () => `opBNB is an optimistic rollup network designed to enhance the scalability of the Binance Smart Chain (BSC). It aims to take the workload away from the mainnet and improve network performance. The opBNB network employs a unique approach to ensure transaction integrity and security. It leverages the main network (BSC) for final transaction validation on its execution layer, facilitated by a verifier mechanism, striving to achieve high throughput while maintaining security.`
